/**
 * @generated SignedSource<<5852356baba0703b7a16e5d78e274427>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutPaneReducer_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly priceBookName: string | null;
      readonly serviceId: string | null;
      readonly validation: {
        readonly buyerShipping: {
          readonly valid: boolean | null;
        } | null;
      } | null;
    } | null> | null;
    readonly personalAddress: {
      readonly priceBookName: string | null;
      readonly serviceId: string | null;
      readonly validation: {
        readonly buyerShipping: {
          readonly valid: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly firstValidShippingAddress: {
    readonly priceBookName: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: "CreditCard";
        readonly isExpired: boolean | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly shippingAddresses: ReadonlyArray<{
        readonly serviceId: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "checkoutPaneReducer_buyer";
};
export type checkoutPaneReducer_buyer$key = {
  readonly " $data"?: checkoutPaneReducer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaneReducer_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutPaneReducer_buyer"
};

(node as any).hash = "9662eda9e0f5bd6f2fcbf35d32902483";

export default node;
